import { Components } from '@mui/material/styles/components';
import { ControllerToggleButtonColor } from '../../palette';
import theme from '../../provider/controllerBaseTheme';

export const ToggleButtonComponent: Components = {
  MuiToggleButton: {
    defaultProps: {
      color: 'primary',
    },
    styleOverrides: {
      root: {
        backgroundColor: String(ControllerToggleButtonColor.ToggledOffBg),
        color: String(ControllerToggleButtonColor.ToggledOffFg),
        textTransform: 'none',
        '&:hover': {
          backgroundColor: String(ControllerToggleButtonColor.ToggledOffBg),
        },
        '&.Mui-selected': {
          boxShadow: 'none',
          backgroundColor: String(ControllerToggleButtonColor.ToggledOnBg),
          color: String(ControllerToggleButtonColor.ToggledOnFg),
          '&:hover': {
            backgroundColor: String(ControllerToggleButtonColor.ToggledOnBg),
          },
        },
      },
    },
  },
  MuiToggleButtonGroup: {
    styleOverrides: {
      grouped: {
        '&:not(:first-of-type)': {
          borderLeftColor: theme.palette.divider,
          '&.Mui-disabled': {
            borderLeftColor: 'rgba(0,0,0,0.12)',
          },
        },
      },
    },
  },
};
